module.exports = __webpack_public_path__ + "static/media/banner.15ca7842.jpg";